export default function useResponsiveLayout() {
  const { width } = useWindowSize()

  // 使用computed会出现Hydration mismatch
  // const isMiddleWidth = computed(() => width.value <= 1000)
  const isMiddleWidth = ref(false)
  const isMinWindowWidth = ref(false)
  const isMax1920Width = ref(false)
  const isLessThan750 = ref(false)
  function getMainWidth() {
    if (width.value < 1000) {
      isMiddleWidth.value = true
      if (width.value < 750) {
        isLessThan750.value = true
      }
      else {
        isLessThan750.value = false
      }
      if (width.value < 449) {
        isMinWindowWidth.value = true
      }
      else {
        isMinWindowWidth.value = false
      }
      isMax1920Width.value = false
    }
    else {
      isMinWindowWidth.value = false
      isMiddleWidth.value = false
      isLessThan750.value = false
      if (width.value >= 1920) {
        isMax1920Width.value = true
      }
    }
  }
  onMounted(() => {
    getMainWidth()
  })
  watch(width, () => {
    getMainWidth()
  })
  return {
    isMiddleWidth,
    isMinWindowWidth,
    isMax1920Width,
    isLessThan750,
  }
}
